/* eslint-disable import/prefer-default-export */

export const setExpandRows = (rows, expanded) => {
  if (typeof expanded !== 'boolean') return rows
  return rows.map((item) => ({ ...item, expanded }))
}
